import { useState, useMemo } from "react";
import type { MunicipalityApi } from "@/lib/api";
import { codeLabel } from "@/config/projetos-config";

interface MunicipalitiesTableProps {
  municipalities: MunicipalityApi[];
}

export default function MunicipalitiesTable({ municipalities }: MunicipalitiesTableProps) {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return municipalities.filter(
      (m) => !q || m.name.toLowerCase().includes(q) || (m.ibge_code ?? "").includes(q)
    );
  }, [municipalities, search]);

  if (municipalities.length === 0) {
    return <p className="text-sm text-foreground-500">Nenhum município cadastrado.</p>;
  }

  return (
    <div className="space-y-4">
      <div className="relative max-w-sm">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
        <input type="text" placeholder="Buscar município ou código IBGE..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-4 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200">
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Município</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">UF</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Código IBGE</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((m) => (
              <tr key={m.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3 text-foreground-900 font-medium">{m.name}</td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{m.uf}</td>
                <td className="py-2.5 px-3 text-foreground-500 text-xs font-mono">{m.ibge_code ?? "—"}</td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{codeLabel({}, m.status)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
